import { IDBPDatabase, openDB } from 'idb';
const DB_KEY = 'amaginow';

export async function openIndexDB(store: string) {
  const db = await openDB(DB_KEY, 2, {
    upgrade(db) {
      db.createObjectStore(store);
    },
  });
  return db;
}

export async function getDataFromIDB(
  key: string,
  store: string,
  db: IDBPDatabase<unknown>,
) {
  return db.get(store, key);
}

export async function setDataInIDB(
  key: string,
  value: any,
  store: string,
  db: IDBPDatabase<unknown>,
) {
  return db.put(store, value, key);
}

export type { IDBPDatabase };
